export const ios = "IOS";
export const android = "ANDROID";
export const browser = "BROWSER";

export const getPlatformType = () => {
  const isAndroid = (typeof JSInterface === 'object');
  const isIos = window.webkit && !isChromeBrowser();
  // Chrome in iOS have window.webkit object created.
    
  if (isAndroid) return android;
  if (isIos) return ios;
  return browser;
}

export const isBrowserDevice = () => {
  return getPlatformType() == browser
}

export const isSafariBrowser = () => {
  const uA = navigator.userAgent;
  const vendor = navigator.vendor;
  return /Safari/i.test(uA) && /Apple Computer/.test(vendor) && !/Mobi|Android/i.test(uA)
}

export const isChromeBrowser = () => {
  return /CriOS/.test(navigator.userAgent) || /Google Inc/.test(navigator.vendor);
}

export const userMediaRequest = (platform) => {
  const width = parseInt(process.env.VUE_APP_PHOTO_WIDTH)
  const height = parseInt(process.env.VUE_APP_PHOTO_HEIGHT)

  if (platform === android) {
    JSInterface.skGetUserMedia(width, height)
  } else if (platform === ios) {
    window.webkit.messageHandlers.skGetUserMedia.postMessage({width, height})
  } else {
    alert('Error getting user media request');
  }
}

export const userQRRequest = (platform) => {
  if (platform === android) {
    JSInterface.skGetUserQR();
  } else if (platform === ios) {
    window.webkit.messageHandlers.skGetUserQR.postMessage('');
  } else {
    alert('Error getting user QR request');
  }
}

export const requestRefreshToken = (platform) => {
  if (platform === android) {
    JSInterface.skRequestRefreshUserToken();
  } else if (platform === ios) {
    window.webkit.messageHandlers.skRequestRefreshUserToken.postMessage('');
  } else {
    alert('Error getting TOKEN renew request');
  }
}